import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { DocumentAuditLifeCycleComponent } from './document-audit-life-cycle/document-audit-life-cycle.component';
import { DocumentAuditSummaryComponent } from './document-audit-summary/document-audit-summary.component';
import { AuditTrailComponent } from './audit-trail.component';
import {FieldsetModule} from 'primeng/fieldset';
import { SharedModule } from '../shared/shared.module';
import { BptProgressSpinnerModule } from 'bpt-ui-library/bpt-progress-spinner';
import { ToastModule } from 'primeng/toast';
import { SpinnerComponent } from '../shared-components/spinner/spinner.component';

@NgModule({
  declarations: [
    DocumentAuditLifeCycleComponent,
    DocumentAuditSummaryComponent,
    AuditTrailComponent
  ],
  imports: [
    CommonModule,
    FieldsetModule,
    SharedModule,
    BptProgressSpinnerModule,
    ToastModule,
    SpinnerComponent
  ],
  exports:[
    AuditTrailComponent
  ]
})
export class AuditTrailModule { }
